import UploadPhotoPage from './UploadPhotoPage'

export default UploadPhotoPage